import { yoloRegistrationPath } from '@ytl/common-model';
import { getConfig } from './shared/data/config';

export const AppRoutes = {
  homepage: '/',
  mfaSetup: '/mfa-beallitas',
  registrationCompleted: '/regisztracio-kesz',
  notfound: '/404',
  errorPage: '/hiba',

  forgottenPassword: {
    _: '/elfelejtett-jelszo',
    withEmail: (email: string) => `/elfelejtett-jelszo?email=${email}`,
  },
  //mar beloggolt user szamara "jelszo modositas"
  changePassword: '/jelszo-valtoztatas',
  //be nem lepett user szamara "elfelejtett jelszo tms sessionidvel"
  forgottenPasswordSet: '/jelszo-beallitas',

  emailConfirm: '/email-visszaigazolas',
  emailChange: '/email-csere',
  emailChangeBlock: '/email-csere-tiltas',

  phoneChange: '/telefonszam-csere',

  smsLoginError: '/sms-belepes-hiba',

  // B2B routes
  registerB2b: '/regisztraciob2b',

  yeppRegister: '/yepp-regisztracio',

  onboarding: '/onboarding',
  kycInit: '/kyc-init',
  kycOk: '/kyc-back-ok',
  kycNok: '/kyc-back-no-ok',

  lockout: '/lockout',

  //YT-1089
  yoloRegister: yoloRegistrationPath,

  nonActiveAccount: getConfig().NonActiveAccountUrl,

  isAuthenticatedView(pathname: string) {
    return (
      [
        AppRoutes.homepage,
        AppRoutes.changePassword,
        AppRoutes.mfaSetup,
        AppRoutes.emailChange,
        AppRoutes.phoneChange,
        AppRoutes.smsLoginError,
      ].indexOf(pathname) > -1
    );
  },

  goToYettel() {
    window.location.href = getConfig().mainYettelUrl;
  },
  goToYettelB2B() {
    window.location.href = getConfig().mainYettelUrlB2B;
  },
  goToYettelAccount() {
    window.location.href = '/';
  },
  goToWebLoginUrl() {
    window.location.href = getConfig().webLoginUrl;
  },
  goToLogout() {
    window.location.href = getConfig().openamLogoutUrl;
  },
};

// EMAIL_VERIFICATION_URL=https://uat15-alm.yettel.hu/email-visszaigazolas?session-id={0}
// OTPEMAIL_VERIFICATION_URL=selfcareapp://yolo/verification?session={0}&code={1}
// PASSWORD_INIT_URL=https://uat15-alm.yettel.hu/kezdeti-jelszo-beallitas?session-id={0}
// PASSWORD_RESET_URL=https://uat15-alm.yettel.hu/jelszo-beallitas?session-id={0}
